import React, { useEffect, useState } from "react";
import ComiteContent from "../commons/ComiteContent";
import { getReviewerByReviewerCategory } from "../../services/author.service";
import { secretariatInfo } from "../../data/comitesList.data";

const categories = [
    { id: 1, titleColor: "text-greenlogo" }, // Comité de rédaction
    { id: 2, titleColor: "text-greenlogo" }, // Comité scientifique
];

const ComiteSection = () => {
    const [comiteData, setComiteData] = useState([]);

    useEffect(() => {
        const fetchComites = async () => {
            try {
                const results = await Promise.all(
                    categories.map(cat => getReviewerByReviewerCategory(cat.id))
                );
                setComiteData(
                    results.map((res, idx) =>
                        res.success && res.data.length
                            ? {
                                title: res.data[0].name_cat_rev,
                                description: res.data[0].description_cat_rev,
                                members: res.data[0].reviewers,
                                titleColor: categories[idx].titleColor,
                            }
                            : null
                    ).filter(Boolean)
                );
            } catch (error) {
                setComiteData([]);
            }
        };
        fetchComites();
    }, []);

    return (
        <div className="flex justify-center w-full">
            <div className="w-full max-w-7xl px-4 sm:px-6">
                {/* En-tête */}
                <p className="text-gray-700 mb-4 leading-relaxed sm:leading-loose mt-4">
                    La revue est dotée d'un secrétariat de rédaction, d'un comité éditorial et d'un comité scientifique.
                </p>
                <h2
                    className={`text-3xl font-semibold mb-2 sm:mb-4 flex items-center ${secretariatInfo.titleColor}`}
                >
                    Sécrétariat de rédaction
                </h2>
                <p className="text-gray-700 mb-2 sm:mb-4 leading-relaxed sm:leading-loose">
                    {secretariatInfo.description}
                </p>
                {/* Comités dynamiques */}
                {comiteData.map((comite, index) => (
                    <div key={index} className="mb-6 sm:mb-8">
                        <ComiteContent
                            title={comite.title}
                            description={comite.description}
                            members={comite.members}
                            titleColor={comite.titleColor}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ComiteSection;